import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PrintStore } from '@app/@shared';
import { IneDTO, IneDTOcall, ParticipantIneDTO } from '@app/requests/model/ine-model';
import { PrintContractDTO } from '@app/requests/model/requests-model';
import { Observable } from 'rxjs';
import { IneSignatureApi } from './ine-signature.service';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';

@Injectable()
export class IneSignatureStore {
  constructor(private ineSignatureApi: IneSignatureApi, private printStore: PrintStore, public dialog: MatDialog) {}

  public printIne(printIne: PrintContractDTO) {
    console.log('Method: printIne', printIne);
    this.printStore.printContract(printIne).then(
      (data) => {
        if (data) {
          this.printStore.openPDFOnSuccess(data, printIne.numOperation, printIne.language, 'INE', printIne);
        }
      },
      (error) => {
        this.showDialogError(error);
      }
    );
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  public sendSMS(participant: ParticipantIneDTO): Observable<any> {
    return this.ineSignatureApi.sendSMS(participant);
  }

  public getparticipantsINE(ineDTO: IneDTOcall): Observable<IneDTO> {
    return this.ineSignatureApi.getParticipantsPendingINE(ineDTO);
  }

  setRequestIneSelected(selected: IneDTOcall) {
    localStorage.setItem('ine', JSON.stringify(selected));
  }

  getRequestIneSelected() {
    return JSON.parse(localStorage.getItem('ine'));
  }
}
